import { Link } from 'react-router-dom';
import { useMyDay } from '../dashboard/executive/myDayData';
import { QueryState } from '../dashboard/executive/MyDaySections';

/** Personal mode of FollowUpsAdminPage, with no team assignment controls. */
export function PersonalFollowUps() {
  const query = useMyDay();
  return <div className="space-y-4">
    <header className="flex justify-between">
      <div>
        <h1 className="text-2xl font-semibold">Follow-ups</h1>
        <p>My follow-ups due through today.</p>
      </div>
      <button className="btn" onClick={query.retry}>Refresh</button>
    </header>
    {!query.data ? <QueryState label="follow-ups" error={query.error} retry={query.retry} /> : <>
      <p>{query.data.day.followupsDue} due · {query.data.day.overdue} overdue</p>
      {query.data.day.due.length === 0 ? <p>No follow-ups due.</p> : <ul className="space-y-3">{query.data.day.due.map(row => <li key={row.id} className="card p-4 flex justify-between items-center">
        <div>
          <strong>{row.name || 'Contact name not recorded'}</strong>
          <p>{new Date(row.at).toLocaleString('en-IN', { timeZone: 'Asia/Kolkata' })}</p>
        </div>
        <Link className="btn" to={row.id.startsWith('lead:') ? '/leads' : '/telecaller'}>{row.id.startsWith('lead:') ? 'Open my leads' : 'Open call queue'}</Link>
      </li>)}</ul>}
    </>}
  </div>;
}
